// Mirror of backend handler shape — keep in lockstep with
// internal/domain/financialinsights/handler/handler_get_status.go.

export interface SessionShape {
  id: string
  status: string
  [key: string]: unknown
}

export interface ReportShape {
  id: string
  /** Mirrors Go fi.Report.AvgWeeklyIncome (json: avgWeeklyIncome). */
  avgWeeklyIncome?: number | null
  /** Mirrors Go fi.Report helper PrimaryBankName() (json: bankName). */
  bankName?: string | null
  [key: string]: unknown
}

export type FinancialInsightsStatus =
  | LiveStatus
  | AuditTombstoneStatus
  | NoneStatus

export interface LiveStatus {
  status: 'initialized' | 'polling' | 'completed' | 'failed'
  session: SessionShape
  report?: ReportShape
}

export interface NoneStatus {
  status: 'none'
}

/**
 * Returned when no live session/report exists but a consent row survives.
 * Carries audit metadata only — never financial fields.
 */
export interface AuditTombstoneStatus {
  status: 'expired' | 'revoked' | 'data_deleted'
  consentedAt: string // ISO 8601
  expiresAt?: string | null // ISO 8601, nullable for legacy pre-PR13 rows
  revokedAt?: string | null // ISO 8601, set when user revoked
  dataDeletedAt?: string | null // ISO 8601, set when reports/sessions purged
}

export const isAuditTombstone = (
  s: FinancialInsightsStatus,
): s is AuditTombstoneStatus =>
  s.status === 'expired' ||
  s.status === 'revoked' ||
  s.status === 'data_deleted'
